<template>
  <b-container fluid>
    <div
      v-if="renderPage"
      fluid="md"
    >
      <transactionComp v-if="hasEcommerce" />
      <no-permission v-else />
    </div>
  </b-container>
</template>

<script>
import {
  BContainer,
} from 'bootstrap-vue'
import TransactionComp from './TransactionComp.vue'
import noPermission from '@/views/error/NoPermission.vue'

import { getMerchantData } from '@/utils/get-merchant-data'

export default {
  components: {
    noPermission,
    TransactionComp,
    BContainer,
  },
  data() {
    return {
      hasEcommerce: false,
      renderPage: true,
    }
  },
  async mounted() {
    await this.checkAccess()
  },
  beforeRouteLeave(to, from, next) {
    this.renderPage = false
    next()
  },
  methods: {
    async checkAccess() {
      // tranfrom session storage permission to array
      const { permissions } = getMerchantData()
      this.hasEcommerce = permissions.map(permission => +permission).some(permissionCode => permissionCode === 3 || permissionCode === 4 || permissionCode === 5)
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "@core/scss/vue/pages/transaction-style.scss";
</style>
